import { render, staticRenderFns } from "./service_detail.vue?vue&type=template&id=03cc040c&scoped=true&"
import script from "./service_detail.vue?vue&type=script&lang=js&"
export * from "./service_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc040c",
  null
  
)

export default component.exports